import React, { useState, useEffect, useContext } from 'react';
import {
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import api from 'utils/api';
import { toast } from 'utils/helpers';
import { CommonDialog } from 'components';
import _ from 'lodash';

const WorkReportPrintModal = ({ objectId, visible, onClose, contractors: propContractors, print }) => {
  const { t } = useTranslation();
  const [period, setPeriod] = useState('');
  const [contractor, setContractor] = useState('');
  const [contractors, setContractors] = useState(propContractors || []);
  const [periods, setPeriods] = useState([]);

  useEffect(() => {
    if (!propContractors && objectId) {
      api.get(`estimates/${objectId}/get-managers-contractors`).then(res => {
        setContractors(res.data.contractors || []);
      }).catch(() => {});
    }
  }, [objectId, propContractors]);

  const report = { 
    formNumber: 'F3', 
    title: t("Lokalinė sąmata"),
    printVariant: t('Atliktų darbų aktas įkainiui'), 
    type: 'workReportsByContractor',
    description: '-'
  };

  const onPrintLocalEstimate = async (params) => {
    const payload = {
        params: ['id', 'period', 'contractor'],
        values: [objectId, period, contractor.label],
        ...params,
    };

    await print(payload);
  };

  const handleContractorSelect = async (newValue) => {
    setContractor(newValue);
    if (newValue) {
      const { data } = await api.post(`work-reports/report-periods-by-contractor`, { estimateId: objectId, contractor: newValue.label });
      if (data?.periods?.length) {
        const periods = data.periods.sort((a, b) => moment(b, 'YYYY-MM').diff(moment(a, 'YYYY-MM')));
        setPeriod(periods[0]);
        setPeriods(periods);
      }
    } else {
      setPeriods([]);
    }
  };

  const handleSubmit = ({ fileType }) => {
    if (!period) {
      toast(t('Įveskite periodą'), 'error');
      return;
    }
    if (!contractor) {
      toast(t('Pasirinkite rangovą'), 'error');
      return;
    }
    onPrintLocalEstimate({ period, contractor, fileType, type: report.type, formNumber: report.formNumber });

    setPeriod(null);
    setPeriods([]);
    setContractor(null);
    onClose();
  };

  return (
    <CommonDialog
      visible={visible}
      onClose={onClose}
      maxWidth="xs"
      style={{ position: 'relative' }}
      actions={[
        <Button color="default" variant="text" onClick={onClose} key="cancel">{t('Atšaukti')}</Button>,
        <Button color="primary" variant="contained" onClick={() => handleSubmit({ fileType: 'PDF' })} key="submit-pdf">{t('Spausdinti (PDF)')}</Button>,
        <Button color="primary" variant="contained" onClick={() => handleSubmit({ fileType: 'XLSX' })} key="submit-xlsx">{t('Spausdinti (Excel)')}</Button>
      ]}
    >
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>{t('Spausdinimo duomenys')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ paddingTop: 0, border: "none" }}>
                <Autocomplete
                  value={contractor}
                  onChange={(event, newValue) => handleContractorSelect(newValue)}
                  options={_.map(contractors, (contractor) => ({ label: contractor }))}
                  style={{ marginTop: 10 }}
                  getOptionLabel={(option) => option?.label?.toString() || option?.toString()}
                  renderInput={(params) => <TextField {...params} label={t("Rangovas")}/>} 
                  ListboxProps={{ style: { maxHeight: '15vh' } }}
                  size="small"
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ paddingTop: 0, border: "none" }}>
                <FormControl fullWidth>
                  <InputLabel fullWidth id="period-label">
                    {t('Periodas')}
                  </InputLabel>
                  <Select
                    value={period || ''}
                    onChange={(e) => setPeriod(e.target.value)}
                    disabled={!periods.length}
                    fullWidth
                    MenuProps={{ style: { maxHeight: '25vh'},
                    }}
                  >
                    {periods?.length > 0 && periods.map((p) => (
                      <MenuItem key={p} value={p}>{p}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </CommonDialog>
  );
};

export default WorkReportPrintModal;
